module.exports = __webpack_public_path__ + "static/media/28.fa52fc8b.png";